import { FolderOpen, ExternalLink, Pencil, Star } from "lucide-react";
import { infoSluzby, podklad } from "@/lib/odkazy";
import { PopisViditelnosti } from "@/components/docs/KdoUvidi";

// 268: složka s dokumenty zakázky na disku firmy (SharePoint / OneDrive / Google Disk).
// Soubory zůstávají na disku firmy, Proyekty jen otevřou složku. Vzor: ProfitPilot SlozkaDokumentu.
// 269: připojuje se přes „Odkaz na soubor“ → Složka zakázky; tady jen řádek připojené složky (bez prázdného rámečku).
// 313: složek může být víc (název) a hvězdička z ní udělá hlavní dokument v Informacích.

export function HvezdaTlacitko({ star, onClick, testid }) {
  return (
    <button type="button" onClick={onClick} aria-pressed={!!star} data-testid={testid}
      aria-label={star ? "Odebrat z hlavních dokumentů" : "Hlavní dokument — ukázat v Informacích"}
      title={star ? "Odebrat z hlavních dokumentů" : "Hlavní dokument — ukázat v Informacích"}
      className={`w-10 h-10 grid place-items-center shrink-0 rounded-full transition-colors ${star ? "text-amber-500 hover:text-amber-600" : "text-muted-foreground hover:text-amber-500"}`}>
      <Star size={17} fill={star ? "currentColor" : "none"} />
    </button>
  );
}

export default function SlozkaDokumentu({ folder, team, onUpravit, onStar, testid = "slozka" }) {
  if (!folder?.url) return null;
  const s = infoSluzby(folder.service || folder.url);
  return (
    <div className="flex items-center gap-2 md:gap-3 rounded-[14px] border border-border p-2.5 pl-3" data-testid={testid}>
      {/* Na telefonu otevírá složku celý řádek, tlačítko Otevřít je až od tabletu (víc místa pro název). */}
      <a href={folder.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 min-w-0 flex-1" data-testid={`${testid}-radek`}>
        <span className="h-10 w-10 rounded-[12px] grid place-items-center shrink-0 dark:brightness-[1.7]" style={{ background: podklad(s.barva), color: s.barva }}>
          <FolderOpen size={19} strokeWidth={1.9} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-[14px] font-bold truncate" data-testid={`${testid}-nazev`}>{folder.name || "Složka zakázky"}</span>
          <span className="block text-[12.5px] text-muted-foreground truncate" data-testid={`${testid}-sluzba`}>
            {s.nazev}<PopisViditelnosti komu={folder.komu} skupiny={folder.skupiny} ai={folder.ai} team={team} />
          </span>
        </span>
      </a>
      {onStar && <HvezdaTlacitko star={folder.star} onClick={onStar} testid={`${testid}-hvezda`} />}
      <a href={folder.url} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-otevrit`}
        className="hidden md:inline-flex h-9 px-3.5 rounded-full bg-foreground text-background text-[13px] font-bold items-center gap-1.5 shrink-0 hover:opacity-90">
        Otevřít <ExternalLink size={14} />
      </a>
      {onUpravit && (
        <button type="button" onClick={onUpravit} aria-label="Upravit složku" title="Upravit složku" data-testid={`${testid}-upravit`}
          className="h-11 w-11 md:h-9 md:w-9 rounded-full bg-secondary grid place-items-center text-muted-foreground hover:text-foreground shrink-0">
          <Pencil size={14} />
        </button>
      )}
    </div>
  );
}
